import { render, staticRenderFns } from "./SolicitarNotaCredito.vue?vue&type=template&id=b4572292&scoped=true&"
import script from "./SolicitarNotaCredito.vue?vue&type=script&lang=js&"
export * from "./SolicitarNotaCredito.vue?vue&type=script&lang=js&"
import style0 from "./SolicitarNotaCredito.vue?vue&type=style&index=0&id=b4572292&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4572292",
  null
  
)

export default component.exports